var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Mail Configuration")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm.loading
              ? _c("v-progress-circular", {
                  attrs: {
                    indeterminate: "",
                    size: "64",
                    color: "primary"
                  }
                })
              : _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("h3", [_vm._v(" Email Configuration Details ")]),
                        _c(
                          "p",
                          {
                            staticClass: "mt-3"
                          },
                          [
                            _c("b", [_vm._v("Username")]),
                            _vm._v(": " + _vm._s(_vm.accountData.account) + " ")
                          ]
                        ),
                        _c("p", [
                          _c("b", [_vm._v("Password")]),
                          _vm._v(": "),
                          _c("i", [_vm._v("Use the email account’s password.")])
                        ]),
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _c("b", [_vm._v("Incoming Server")]),
                            _vm._v(
                              ": " + _vm._s(_vm.accountData.inbox_host) + " "
                            )
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "mb-3"
                          },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.accountData.inbox_service.toUpperCase()
                                ) + " Port"
                              )
                            ]),
                            _vm._v(
                              ": " + _vm._s(_vm.accountData.inbox_port) + " "
                            )
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _c("b", [_vm._v("Outgoing Server")]),
                            _vm._v(
                              ": " + _vm._s(_vm.accountData.smtp_host) + " "
                            )
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "mb-3"
                          },
                          [
                            _c("b", [_vm._v("SMTP Port")]),
                            _vm._v(
                              ": " + _vm._s(_vm.accountData.smtp_port) + " "
                            )
                          ]
                        ),
                        _c("p", [
                          _vm._v(
                            " IMAP, POP3, and SMTP require authentication. "
                          )
                        ]),
                        _c("hr"),
                        _c("h3", [
                          _vm._v(" Send Configuration Detail Via Email ")
                        ]),
                        _c(
                          "p",
                          {
                            staticClass: "mt-3"
                          },
                          [
                            _vm._v(
                              " Send configuration information for “" +
                                _vm._s(_vm.accountData.account) +
                                "” to the following email address: "
                            )
                          ]
                        ),
                        _c(
                          "v-form",
                          [
                            _c("v-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                }
                              ],
                              attrs: {
                                outlined: "",
                                label: "Email",
                                name: "Email",
                                "error-messages": _vm.errors.collect("Email")
                              },
                              model: {
                                value: _vm.settingsEmail,
                                callback: function callback($$v) {
                                  _vm.settingsEmail = $$v
                                },
                                expression: "settingsEmail"
                              }
                            }),
                            _c(
                              "gg-btn",
                              {
                                attrs: {
                                  tile: "",
                                  color: "primary",
                                  loading: _vm.sendingInstructions
                                },
                                on: {
                                  click: _vm.sendInstructions
                                }
                              },
                              [_vm._v("Send Instructions")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }